import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconExcel = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 16 16"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 1h12v14H2V1ZM1 0h14v16H1V0Zm3.064 3.5H6.23l1.768 3.332 1.791-3.33h2.165l-2.63 4.49L12 12.5H9.853L7.997 9.252 6.181 12.5H4l2.662-4.51L4.064 3.5Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconExcel);
export default Memo;
